import { createSlice } from '@reduxjs/toolkit'
import { EquipmentList } from 'app/types/types'

const initialState: EquipmentList = {
  building: [],
  elevator: [],
  escalator: []
}

const equipmentList = createSlice({
  name: 'equipmentList',
  initialState,
  reducers: {
    setEquipmentList: (state, action) => {
      state.building = action.payload.building
      state.escalator = action.payload.escalator
      state.elevator = action.payload.elevator
    },
    clearEquipmentList: () => ({ ...initialState })
  }
})

export const { setEquipmentList, clearEquipmentList } = equipmentList.actions

export default equipmentList.reducer
